<template>
	<div class="recruitment-dashboard">
		<!-- 頂部標題欄 -->
		<div class="page-title u-flex">
			<div>
				<div class="page-title-main">招生儀表板</div>
				<div class="page-title-sub">{{userInfo.schoolName}}-招生數據中心</div>
			</div>
			<div class="u-flex page-title-btn" style="color: #999999;">
				<div>數據更新：每月 <span style="color: #ED6D00;">1</span> 日</div>
				<div class="btn-down"  @click="dialogVisible=true">
					<img src="@/assets/ic-d.png" style="width:0.16rem;height: 0.16rem;margin-right: 0.05rem;" />
					下載數據報告
				</div>
			</div>
		</div>

		<!-- 日期選擇區域 -->
		<section class="date-section">
			<div class="search-title u-flex">
				<div class="u-flex">
					<img style="margin-right: 0.06rem;" src="@/assets/ic-title.png" />日期與校系篩選
				</div>

				<!-- <span>解鎖其他學校</span> -->
			</div>
			<div class="date-container">
				<div class="date-input-group">
					<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
							src="@/assets/ic-date.png" />月份</label>
					<!-- <el-date-picker value-format="yyyy-MM-dd" clearable @change="initData" class="input-date" v-model="search.startDate" type="date" placeholder="年/月/日">
					</el-date-picker> -->
					<el-date-picker :picker-options="pickerOptions" type="month" value-format="yyyy-MM"
						class="input-date" clearable @change="initData" v-model="search.yearMonth" placeholder="年/月">
					</el-date-picker>
				</div>
				<div class="date-input-group">
					<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
							src="@/assets/ic-1.png" />選擇學校</label>
					<el-input class="input-date input-date1" disabled v-model="search.schoolName" type="text"
						placeholder=" ">
					</el-input>
					<!-- <el-select @change="changeSchool" placeholder=" " filterable class="input-date input-date1" v-model="search.schoolName">

						<el-option v-for="(item,index) in schoolList" :key="item.name" :label="item.name"
							:value="item.name">
						</el-option>

					</el-select> -->
				</div>
				<div class="date-input-group">
					<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
							src="@/assets/ic-2.png" />選擇學系</label>

					<el-select filterable clearable @change="initData" placeholder="" class="input-date"
						v-model="search.departmentName">
						<el-option v-for="(item,index) in collegeList" :key="item.id" :label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
				</div>
			</div>
		</section>

		<section class="modle-block2">
			<!-- 核心數據指標 -->
			<section class="kpi-section">
				<h2 class="section-title u-flex">

					<img style="margin-right: 0.06rem;" src="@/assets/ic-title.png" />核心數據指標
					<span class="ranking-title-tips">
							<img
							style="margin-right: 0.02rem;width: 0.14rem;height: 0.14rem;"
							src="@/assets/ic-time.png" />{{search.yearMonth || '過去30天'}}</span>
					
				</h2>
				<div class="kpi-grid">
					<div class="kpi-card">
						<img class="ic-block" src="@/assets/block2.png" />
						<div class="kpi-header">
							<span class="kpi-name">使用者總數</span>
						</div>
						<div class="kpi-content">
							<div class="kpi-value">{{coreData.userCount || 0}}</div>
							
							<!-- <div class="kpi-comparison positive" v-if="search.yearMonth"
								:class="coreData.userRate<0?'positive-red':''">
								<span class="trend-icon" v-if="coreData.userRate>0">↑</span>
								<span class="trend-icon" v-else>↓</span>
								<span class="percentage">{{coreData.userRate || 0}}%</span>
								<span class="period">與上月同期比較
								</span>
							</div> -->
						</div>
					</div>

					<div class="kpi-card">
						<img class="ic-block" src="@/assets/block3.png" />
						<div class="kpi-header">
							<span class="kpi-name">總瀏覽量</span>
						</div>
						<div class="kpi-content">
							<div class="kpi-value">{{coreData.visitCount || 0}}</div>
							<!-- <div class="kpi-comparison positive" v-if="search.yearMonth"
								:class="coreData.visitRate<0?'positive-red':''">
								<span class="trend-icon" v-if="coreData.visitRate>0">↑</span>
								<span class="trend-icon" v-else>↓</span>
								<span class="percentage">{{coreData.visitRate || 0}}%</span>
								<span class="period">與上月同期比較
								</span>
							</div> -->
						</div>
					</div>

					<div class="kpi-card">
						<img class="ic-block" src="@/assets/block4.png" />
						<div class="kpi-header">
							<span class="kpi-name">平均捲動深度</span>
						</div>
						<div class="kpi-content">
							<div class="kpi-value">{{coreData.avgDepth || 0}}%</div>
							<!-- <div class="kpi-comparison positive" v-if="search.yearMonth"
								:class="coreData.avgDepthRate<0?'positive-red':''">
								<span class="trend-icon" v-if="coreData.avgDepthRate>0">↑</span>
								<span class="trend-icon" v-else>↓</span>
								<span class="percentage">{{coreData.avgDepthRate || 0}}%</span>
								<span class="period">與上月同期比較
								</span>
							</div> -->
						</div>
					</div>
					<div class="kpi-card">
						<img class="ic-block" src="@/assets/block1.png" />
						<div class="kpi-header">
							<span class="kpi-name">平均投入時間</span>
						</div>
						<div class="kpi-content">
							<div class="kpi-value">{{coreData.avgTime || 0}}</div>
							<!-- <div class="kpi-comparison positive" v-if="search.yearMonth"
								:class="coreData.avgTimeRate<0?'positive-red':''">
								<span class="trend-icon" v-if="coreData.avgTimeRate>0">↑</span>
								<span class="trend-icon" v-else>↓</span>
								<span class="percentage">{{coreData.avgTimeRate || 0}}%</span>
								<span class="period">與上月同期比較
								</span>
							</div> -->
						</div>
					</div>
				</div>
			</section>

			<!-- 中間內容區域 -->
			<div class="ranking-section">
				<div class="ranking-header">
					<h3 class="ranking-title u-flex"><img style="margin-right: 0.06rem;"
							src="@/assets/ic-title.png" />全校每月排行榜
						<span class="ranking-title-tips">
								<img
								style="margin-right: 0.02rem;width: 0.14rem;height: 0.14rem;"
								src="@/assets/ic-time.png" />{{search.yearMonth || searchSchool.month}}</span>
					</h3>
					<!-- <div class="ranking-date">檢視前 5 名<i style="margin-left: 0.02rem;" class="el-icon-arrow-right"></i>
					</div> -->
				</div>
				<div class="date-container">
					<!-- <div class="date-input-group">
						<label class="date-label">月份</label>
						<el-date-picker :picker-options="pickerOptions" type="month" value-format="yyyy-MM"
							class="input-date" clearable @change="initSchoolRank" v-model="searchSchool.month"
							placeholder="">
						</el-date-picker>
					</div> -->
					<div class="date-input-group">
						<label class="date-label">排名依據</label>

						<el-select placeholder="" clearable @change="initSchoolRank" class="input-date"
							v-model="searchSchool.orderBy">

							<el-option label="瀏覽數" value="1">
							</el-option>
							<el-option label="捲動深度" value="2">
							</el-option>
							<el-option label="成長率" value="3">
							</el-option>
						</el-select>
					</div>
					<div class="date-input-group">
						<label class="date-label">比較基準</label>

						<el-select placeholder="" clearable @change="initSchoolRank" class="input-date"
							v-model="searchSchool.compareBase">

							<el-option label="與上月比較" value="1">
							</el-option>
							<el-option label="與上季比較" value="2">
							</el-option>
							<el-option label="與去年同期比較" value="3">
							</el-option>

						</el-select>
					</div>
				</div>
				<div class="era-table-container">
					<div class="ranking-table" style="min-width:4rem;">
						<div class="table-header">
							<span>排名</span>
							<span>系名</span>
							<span>瀏覽數</span>
							<span>捲動深度</span>
							<span>成長率</span>
						</div>
						<div class="table-row" v-for="(item,index) in schoolRank" :key="index">
							<span class="rank">{{ item.indexNo }}</span>
							<span class="department">{{ item.departmentName }}</span>
							<span class="area">{{ item.visitCount }}</span>
							<span :class="[item.type,'rate']">{{ item.avgDepth }}</span>
							<span class="rate">{{ item.rate }}</span>
						</div>

						
					</div>
					<div class="era-search u-flex" style="justify-content: center;margin-top: 0.2rem;">
						<el-pagination :page-size="5" @current-change="currentChangeRank" background :pager-count="5"
							layout="prev, pager, next" :total="schoolRankTotal">
						</el-pagination>
					</div>
				</div>
			</div>
		</section>

		<div class="era-content-grid">
			<!-- 左侧排行榜 -->
			<section class="era-ranking-section">
				<div class="era-section-header">
					<h2 class="era-section-title u-flex">
						<img style="margin-right: 0.06rem;" src="@/assets/ic-title.png" />
						學生興趣與曝光分析
					</h2>
					<div class="era-section-title-sub">全站熱門學類排行</div>
				</div>

				<div class="era-table-container">
					<div class="ranking-table ranking-table8rem" style="margin: 0;">
						<div class="table-header">
							<span>排名</span>
							<span>學類名稱</span>
							<span>全站瀏覽數</span>
							<span>和上月比較</span>
							<span>本校瀏覽數</span>
						</div>
						<div class="table-row" v-for="item in rmxlData" :key="item.rank">
							<span class="rank">{{ item.indexNo }}</span>
							<span class="department">{{ item.type }}</span>
							<span class="area">{{ item.visitCount }}</span>
							<span :class="[item.visitRate>=0?'on':'','up']">{{ item.visitRate }}%</span>
							<span class="rate">{{ item.schoolCount }}</span>
						</div>
					</div>
					<div class="era-search u-flex" style="justify-content: center;margin-top: 0.2rem;">
						<el-pagination @current-change="currentChangeRmxl" background :pager-count="5"
							layout="prev, pager, next" :total="rmxlTotal">
						</el-pagination>
					</div>
					
				</div>
			</section>

			<!-- 右侧数据面板 -->
			<section class="era-stats-panel">
				<!-- 使用者数控比分练 -->
				<div class="era-chart-section">
					<h3 class="era-section-title-sub">使用者來源分析</h3>
					<div class="era-channel-list">
						<div id="one"></div>
						<!-- <div class="era-channel-item" v-for="channel in channels" :key="channel">
              <span class="era-channel-dot" :class="getChannelClass(channel)"></span>
              <span class="era-channel-name">{{ channel }}</span>
            </div> -->
					</div>
				</div>

				<!-- 流量管道品质评比 -->
				<div class="era-quality-section">
					<!-- <h3 class="era-section-title-sub">流量管道品質評比(TOP 5)</h3> -->

					<div class="era-table-container">
						<div class="ranking-table" style="margin: 0;min-width:4rem;">
							<div class="table-header">
								<span>流量來源</span>
								<span>佔比(%)</span>

								<!-- <span>瀏覽數</span> -->
								<span>平均捲動深度</span>

							</div>
							<div class="table-row" v-for="item in qualityData" :key="item.channel">
								<span class="rank">{{ item.source }}</span>
								<span class="department">{{ item.visitRate }}</span>
								<!-- <span class="area">{{ item.visitCount }}</span> -->
								<span class="area">{{ item.avgDepth }}%</span>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
		
		<el-dialog title="下載數據報告" :close-on-click-modal="false" :visible.sync="dialogVisible" class="dialog-down">
		
				<div class="date-container">
					<div class="date-input-group">
						<label class="date-label">報告類型</label>
		
						<el-select clearable placeholder=" " filterable class="input-date input-date1"
							v-model="searchDown.statType">
		
							<el-option v-for="(item,index) in statTypeList" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
		
						</el-select>
					</div>
				</div>
				<div class="date-container" style="display: block;" v-if="searchDown.statType">
					
		
					<div class="date-input-group" style="margin-top: 0.15rem;"
						v-if="searchDown.statType==3 || searchDown.statType==5">
						
						<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
								src="@/assets/ic-date.png" />年份</label>
					
						
						<el-select clearable placeholder=" " filterable class="input-date input-date1"
							v-model="searchDown.statYear">
						
							<el-option v-for="(item,index) in yearList" :key="item" :label="item"
								:value="item">
							</el-option>
						
						</el-select>
					</div>
					<div v-else>
						<div class="date-input-group" style="margin-top: 0.15rem;">
							
							<label class="date-label"><img class="input-icon" style="margin-right: 0.02rem;"
									src="@/assets/ic-date.png" />月份</label>
							
							<el-date-picker :picker-options="pickerOptionsDown" type="month" value-format="yyyy-MM"
								class="input-date" clearable v-model="searchDown.yearMonth" placeholder="年/月">
							</el-date-picker>
						</div>
					</div>
		
		
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button size="medium" @click="dialogVisible = false">取 消</el-button>
					<el-button size="medium" type="primary" @click="toDown">確認下載</el-button>
				</span>
			</el-dialog>
	</div>
</template>

<script>
	import {
		apiBaseUrl
	} from '@/api/config.js';
	export default {
		name: 'RecruitmentDashboard',
		data() {
			return {
				dialogVisible: false,

				searchDown: {
					statYear: '',
					statMonth: '',
					yearMonth: '',
					schoolName: ''
				},
				pickerOptionsDown: {
					disabledDate: (time) => {
						const date = time;
						  const current = new Date();
						
						  // 最小日期为2025年11月1日
						  const minDate = new Date(2025, 10, 1);
						  minDate.setHours(0, 0, 0, 0);
						
						  // 最大日期为上个月的最后一天
						  // current.getMonth() 是当前月份(0-11)，上个月就是 current.getMonth()
						  // 因为 new Date(year, month, 0) 会返回上个月的最后一天
						  const maxDate = new Date(current.getFullYear(), current.getMonth(), 0);
						  maxDate.setHours(23, 59, 59, 999);
						
						  console.log('当前月份:', current);
						  console.log('最大可选日期:', maxDate);
						
						  return date.getTime() < minDate.getTime() || date.getTime() > maxDate.getTime();
					}
				},

				pickerOptions: {
					disabledDate: (time) => {
						const date = time;
						const current = new Date();

						// 设置最小日期为2025年11月1日
						const minDate = new Date(2025, 10, 1);

						// 设置最大日期为当前月份的最后一天
						const maxDate = new Date(current.getFullYear(), current.getMonth() + 1, 0);

						return date < minDate || date > maxDate;
					}
				},

				statTypeList: [
				// 	{
				// 	name: "流量明細統計",
				// 	id: '1',
				// }, {
				// 	name: "學校明細統計",
				// 	id: '2',
				// }, 
				{
					name: "學校年統計",
					id: '3',
				}, {
					name: "學校月統計",
					id: '4',
				}, {
					name: "學系年統計",
					id: '5',
				}, {
					name: "學系月統計",
					id: '6',
				}],
				yearList:[],
				search: {
					startDate: '',
					endDate: '',
					schoolName: ''
				},
				searchSchool: {
					topCount: 5,
					month: '',
					orderBy: '',
					compareBase: ''
				},
				rankParams: {
					pageNo: 1,
				},
				rmxlParams: {
					pageNo: 1,
					pageSize:10
				},

				collegeList: [],
				coreData: {},
				schoolRank: [],
				schoolRankTotal: 0,
				rmxlTotal:0,
				rmxlData: [],
				userInfo: {},
				colorAttr: ['#0BA29B', '#FABD00', '#8CC8CC', '#A1DEEA', '#FFB16F', '#0ba29b0f'],
				schoolList: [],
				qualityData: []
			}
		},
		mounted() {
			if (localStorage.getItem('userInfo')) {
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
			}
			this.$nextTick(() => {

				const now = new Date();
				// 设置为上个月的第一天
				now.setMonth(now.getMonth() - 1);
				now.setDate(1);
				
				const year = now.getFullYear();
				const month = String(now.getMonth() + 1).padStart(2, '0');
				
				// 下载年份选择
				const startYear = 2025;
				const endYear = year - 1; // 去年
				
				this.yearList = [];
				for (let year = startYear; year <= endYear; year++) {
				  this.yearList.push(year.toString());
				}
				this.searchSchool.month = `${year}-${month}`;
				this.search.schoolName = this.userInfo.schoolName
				this.searchDown.schoolName = this.userInfo.schoolName
				this.schoolList = [{
					id: this.userInfo.schoolId,
					name: this.userInfo.schoolName
				}]

				this.$axios
					.post("rest-api/member/app/user/getInfo")
					.then((res) => {
						if (res.code == 200) {

							this.changeSchool(this.search.schoolName)
						}
					})
					.catch((err) => {});

			})
		},
		methods: {

			toDown(){
				
				
					if (!this.searchDown.statType) {
				
						this.$message({
							message: '請選擇報告類型',
							type: 'warning'
						});
						return
					}
					this.$loading()
					this.$axios
						.post("rest-api/system/app/bigQuery/export/data", {...this.searchDown})
						.then((res) => {
							this.dialogVisible = false
				
							this.$loading().close()
							window.open(res.data, '_blank');
						})
						.catch((err) => {
				
							this.$loading().close()
						});
				
				
				
				
			},
			changeSchool(e) {
				let id = ''
				this.schoolList.some(item => {
					if (item.name == e) {
						id = item.id
					}
				})
				this.$axios
					.post("rest-api/system/app/schoolDepartment/list", {
						schoolId: id
					})
					.then((res) => {

						this.collegeList = res.data
						this.initData()
					})
					.catch((err) => {});
			},
			initData() {
				this.$loading()
				this.coreData = {}


				this.$axios
					.post("rest-api/system/app/bigQuery/hxzb/data", this.search)
					.then((res) => {

						this.$loading().close()
						if (res.data && res.code == 200) {

							this.coreData = res.data
							
							
							this.initSchoolRank()

							this.initRmxl()
							let post={}
							if(this.search.yearMonth){
								post.startDate=this.search.yearMonth+'-01'
								post.endDate=this.search.yearMonth+'-31'
							}
							this.$axios
								.post("rest-api/system/app/bigQuery/sjly/data", {...this.search,...post})
								.then((res) => {
									this.qualityData = res.data
									let eData = []
									res.data.some((i, index) => {
										let item = {
											value: i.visitCount,
											name: i.source,
											itemStyle: {
												color: this.colorAttr[index]
											}
										}
										eData.push(item)
									})
									this.initCharT(eData)
								})
								.catch((err) => {});
								
						}
					})
					.catch((err) => {});
			},

			initRmxl() {
				this.rmxlParams.pageNo = 1
				this.getRmxl()

			},
			currentChangeRmxl(e) {

				this.rmxlParams.pageNo = e
				this.getRmxl()
			},
			getRmxl() {

				this.$axios
					.post("rest-api/system/app/bigQuery/rmxl/data", {
						...this.search,
						...this.rmxlParams,
					})
					.then((res) => {
						this.rmxlData = res.data.list
						this.rmxlTotal = res.data.total
					})
					.catch((err) => {});
			},
			initSchoolRank() {
				this.rankParams.pageNo = 1
				this.getRank()

			},
			currentChangeRank(e) {

				this.rankParams.pageNo = e
				this.getRank()
			},
			getRank() {
				if(this.search.yearMonth){
					
					this.searchSchool.month=this.search.yearMonth
				}
				this.$axios
					.post("rest-api/system/app/bigQuery/qxphb/data", {
						...this.search,
						...this.rankParams,
						...this.searchSchool
					})
					.then((res) => {
						this.schoolRank = res.data.list
						this.schoolRankTotal = res.data.total
					})
					.catch((err) => {});
			},
			initCharT(data) {
				const option = {
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},
					legend: {
						orient: 'vertical',
						left: 'right',
						top: 'center',
						itemGap: 20,
						textStyle: {
							fontSize: 10
						}
					},
					series: [{
						name: '流量來源',
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['35%', '50%'],
						avoidLabelOverlap: false,
						label: {
							show: false
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 16,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: data
					}]
				};
				var myChartTwo = this.$echarts.init(document.getElementById("one")); //图标初始化\
				myChartTwo.setOption(option);
				window.onresize = function() {
					myChartTwo.resize();
				};
			},

			getChannelClass(channel) {
				const classMap = {
					'Organic Search': 'organic',
					'Referral': 'referral',
					'Social Media': 'social',
					'Paid Search': 'paid',
					'Direct': 'direct'
				}
				return classMap[channel] || 'organic'
			}
		}
	}
</script>

<style scoped lang="scss">
	.recruitment-dashboard {
		min-height: 100vh;
		overflow: hidden;
		background: #EEF3F6;
		padding: 0.2rem;
	}

	/* 頂部標題欄 */
	.dashboard-header {
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
		margin-bottom: 0.2rem;
		box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.1);
	}

	.header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.page-title {}

	.help-btn {
		background: #4a5568;
		color: white;
		border: none;
		padding: 0.08rem 0.2rem;
		border-radius: 0.06rem;
		font-size: 0.2rem;
		cursor: pointer;
	}

	/* 日期選擇區域 */
	.date-section {
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
		margin-bottom: 0.2rem;
	}

	.date-container {
		display: flex;
		gap: 0.2rem;
	}

	.date-input-group {
		flex: 1;
	}

	.date-label {
		display: flex;
		align-items: center;
		margin-bottom: 0.08rem;
		color: #222;
		font-size: 0.18rem;
	}

	.date-input {
		background: #91A2A41A;
		border: 0.01rem solid #91A2A480;
		border-radius: 0.08rem;
		font-size: 0.2rem;
		padding: 0.12rem 0.1rem;
		color: #999;
	}

	/* 核心數據指標 */
	.kpi-section {
		flex: 1;
		margin-right: 0.1rem;
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
	}

	.section-title {
		font-weight: bold;
		font-size: 0.2rem;
		margin-bottom: 0.2rem;
		color: #2d3748;
	}

	.kpi-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(1.8rem, 1fr));
		gap: 0.2rem;
	}

	.kpi-card {
		background: white;
		border-radius: 0.12rem;
		padding: 0.25rem;
		position: relative;
		box-shadow: 0.04rem 0.04rem 0.2rem 0rem #27545726;

		.ic-block {
			width: 0.4rem;
			height: 0.4rem;
			position: absolute;
			top: 0.45rem;
			right: 0.25rem
		}
	}

	.kpi-header {
		margin-bottom: 00.17rem;
	}

	.kpi-name {
		font-size: 0.18rem;
		color: #777;
	}

	.kpi-value {
		font-size: 0.32rem;
		color: #000;
		margin-bottom: 0.4rem;
	}

	.kpi-comparison {
		display: flex;
		align-items: center;
		gap: 0.06rem;
		font-size: 0.14rem;
	}

	.kpi-comparison.positive {
		color: #21C93A;

		&.positive-red {
			color: #FF4A4A;

		}
	}

	.trend-icon {
		font-weight: bold;
	}

	/* 主要內容區域 */
	.main-content {
		flex: 1;
		margin-left: 0.1rem;
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
	}

	.content-grid {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: 0.3rem;
	}

	/* 排行榜樣式 */
	.ranking-section {
		flex: 1;
		margin-left: 0.1rem;
		background: white;
		border-radius: 0.12rem;
		padding: 0.2rem;
		box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
	}

	.ranking-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.1rem;
	}

	.ranking-title {
		font-size: 0.2rem;
		font-weight: bold;
		color: #2d3748;
		margin-bottom: 0.2rem;
	}


		.ranking-title-tips {
			color: #ED6D00;
			font-size: 0.12rem;
			font-weight: normal;
			margin-left: 0.2rem;
		}
	.ranking-table {
		border: 0.01rem solid #27545726;
		border-radius: 0.1rem;
		margin-top: 0.2rem;
		overflow: hidden;
	}

	.ranking-date {
		color: #0BA29B;
		font-size: 0.16rem;
	}

	.ranking-subtitle {
		color: #718096;
		font-size: 0.2rem;
		margin-bottom: 0.2rem;
	}

	.table-header {
		display: flex;
		padding: 0.12rem 0;
		font-size: 0.18rem;
		border-bottom: 0.01rem solid #e2e8f0;
		background: #0BA29B0F;
		color: #4a5568;
	}

	.table-header span {
		flex: 1;
		text-align: center;
	}

	.table-row span {
		flex: 1;
		text-align: center;
	}

	.table-row .up {
		color: #FF4A4A;

		&.on {
			color: #21C93A;
		}
	}

	.table-row {
		display: flex;
		font-size: 0.18rem;
		padding: 0.12rem 0;
		border-bottom: 0.01rem solid #e2e8f0;
	}

	.rank {
		color: #4a5568;
	}

	.department {
		color: #2d3748;
	}

	.area,
	.rate {
		text-align: right;
		color: #4a5568;
	}

	/* 篩選區域樣式 */
	.filter-section {
		background: white;
		border-radius: 0.12rem;
		padding: 0.2rem;
		box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
	}

	.filter-group {
		display: flex;
		gap: 0.1rem;
		margin-bottom: 0.2rem;
	}

	.filter-btn {
		flex: 1;
		padding: 0.1rem;
		border: 0.01rem solid #e2e8f0;
		background: #f7fafc;
		border-radius: 0.08rem;
		cursor: pointer;
		transition: all 0.3s;
	}

	.filter-btn.active {
		background: #667eea;
		color: white;
		border-color: #667eea;
	}

	.primary-btn {
		width: 100%;
		padding: 0.12rem;
		background: #667eea;
		color: white;
		border: none;
		border-radius: 0.08rem;
		font-size: 0.2rem;
		cursor: pointer;
		margin-bottom: 0.2rem;
	}

	.dropdown {
		width: 100%;
		padding: 0.12rem;
		border: 0.01rem solid #e2e8f0;
		border-radius: 0.08rem;
		background: white;
		margin-bottom: 0.2rem;
	}

	.stats-info {
		display: flex;
		flex-direction: column;
		gap: 0.12rem;
	}

	.stat-item {
		padding: 0.1rem;
		background: #f7fafc;
		border-radius: 0.06rem;
		text-align: center;
		color: #718096;
		font-size: 0.2rem;
	}

	/* 響應式設計 */
	@media (max-width: 1024px) {
		.content-grid {
			grid-template-columns: 1fr;
			gap: 0.2rem;
		}
	}

	@media (max-width: 768px) {
		.recruitment-dashboard {
			padding: 0.1rem;
		}

		.kpi-section {

			margin-bottom: 0.2rem;
		}

		.ranking-date {
			margin-bottom: 0.2rem;
		}

		.header-content {
			flex-direction: column;
			gap: 00.17rem;
			align-items: flex-start;
		}

		.date-container {
			flex-direction: column;
			gap: 00.17rem;
		}

		.kpi-grid {
			grid-template-columns: 1fr;
		}

		.table-header,
		.table-row {
			grid-template-columns: 0.5rem 1fr 0.8rem 0.7rem;
			gap: 0.1rem;
			font-size: 0.18rem;
		}

		.filter-group {
			flex-direction: column;
		}
	}

	@media (max-width: 480px) {
		.kpi-value {
			font-size: 0.24rem;
		}

		.table-header,
		.table-row {
			grid-template-columns: 0.4rem 1fr 0.7rem 0.6rem;
			gap: 0.08rem;
		}

		.ranking-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 0.1rem;
		}
	}

	.search-title {
		font-weight: bold;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.28rem;

		span {
			color: #0BA29B;
			font-weight: normal;
			font-size: 0.18rem;
			cursor: pointer;
		}
	}

	.modle-block2 {
		display: flex;
	}

	@media (max-width: 1024px) {
		.modle-block2 {
			display: block;
		}

		.kpi-section {
			margin-right: 0;
		}

		.ranking-section {
			margin-left: 0;
		}
	}

	/* 页面标题 */
	.era-header {
		margin-bottom: 0.3rem;
	}

	.era-main-title {
		font-size: 0.28rem;
		font-weight: 700;
		color: #2d3748;
		text-align: center;
	}

	/* 内容网格布局 */
	.era-content-grid {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: 0.3rem;
		margin: 0 auto;
	}

	/* 排行榜区域 */
	.era-ranking-section {}

	.era-section-header {}

	.era-section-title {
		font-size: 0.2rem;
		font-weight: bold;
		color: #2d3748;
	}

	.era-section-title-sub {
		font-size: 00.19rem;
		font-weight: bold;
		color: #0BA29B;
		margin-bottom: 0.2rem;
		margin-top: 0.2rem;
	}

	/* 表格样式 */
	.era-table-container {
		overflow-x: auto;
	}

	.era-ranking-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 0.2rem;
	}

	.era-ranking-table th {
		background: #f8fafc;
		padding: 0.12rem 0.08rem;
		text-align: left;
		font-weight: bold;
		color: #4a5568;
		border-bottom: 0.02rem solid #e2e8f0;
	}

	.era-ranking-table td {
		padding: 0.12rem 0.08rem;
		border-bottom: 0.01rem solid #e2e8f0;
		color: #4a5568;
	}

	.era-ranking-table .era-highlight-row {
		background: #fffaf0;
	}

	.era-ranking-table .era-highlight-row td {
		font-weight: 500;
	}

	.era-rank-col {
		width: 0.6rem;
	}

	.era-name-col {
		min-width: 2rem;
	}

	.era-private-col {
		width: 1.2rem;
	}

	.era-growth-col {
		width: 1rem;
	}

	.era-school-col {
		width: 1.4rem;
	}

	.era-rank-cell {
		text-align: center;
	}

	.era-rank-number {
		display: inline-block;
		width: 0.28rem;
		height: 0.28rem;
		line-height: 0.28rem;
		text-align: center;
		background: #667eea;
		color: white;
		border-radius: 50%;
		font-size: 0.12rem;
		font-weight: bold;
	}

	.era-ranking-table .era-highlight-row .era-rank-number {
		background: #ed8936;
	}

	.era-name-cell {
		color: #2d3748;
		font-weight: 500;
	}

	.era-growth-cell {
		text-align: center;
	}

	.era-growth-rate.era-positive {
		color: #48bb78;
		font-weight: bold;
	}

	.era-school-cell {
		text-align: right;
	}

	/* 右侧数据面板 */
	.era-stats-panel {
		display: flex;
		flex-direction: column;
		gap: 0.25rem;
		padding-top: 0.4rem;
	}

	.era-chart-section,
	.era-quality-section {
		background: #EEF6F685;
		border-radius: 00.17rem;
		padding: 0.18rem;
	}

	.era-chart-title {
		font-size: 0.2rem;
		font-weight: bold;
		color: #2d3748;
		margin-bottom: 0.2rem;
	}

	/* 管道列表 */
	.era-channel-list {
		display: flex;
		flex-direction: column;
		gap: 0.12rem;
	}

	.era-channel-item {
		display: flex;
		align-items: center;
		gap: 0.1rem;
		padding: 0.08rem 0;
	}

	.era-channel-dot {
		width: 0.12rem;
		height: 0.12rem;
		border-radius: 50%;
	}

	.era-channel-dot.era-organic {
		background: #48bb78;
	}

	.era-channel-dot.era-referral {
		background: #ed8936;
	}

	.era-channel-dot.era-social {
		background: #9f7aea;
	}

	.era-channel-dot.era-paid {
		background: #4299e1;
	}

	.era-channel-dot.era-direct {
		background: #f56565;
	}

	.era-channel-name {
		color: #4a5568;
		font-size: 0.2rem;
	}

	/* 品质评比表格 */
	.era-quality-table {
		display: flex;
		flex-direction: column;
		gap: 00.17rem;
	}

	.era-table-header {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 00.17rem;
		padding-bottom: 0.1rem;
		border-bottom: 0.02rem solid #e2e8f0;
		font-weight: bold;
		color: #4a5568;
		font-size: 0.12rem;
	}

	.era-table-body {
		display: flex;
		flex-direction: column;
		gap: 0.12rem;
	}

	.era-table-row {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 00.17rem;
		align-items: center;
	}

	.era-channel-cell {
		font-size: 0.12rem;
		color: #4a5568;
		font-weight: 500;
	}

	.era-progress-cell {
		position: relative;
	}

	.era-progress-bar {
		position: relative;
		height: 0.24rem;
		background: #f7fafc;
		border-radius: 0.12rem;
		overflow: hidden;
	}

	.era-progress-fill {
		height: 100%;
		background: linear-gradient(90deg, #667eea, #764ba2);
		border-radius: 0.12rem;
		transition: width 0.3s ease;
	}

	.era-progress-fill.era-depth-fill {
		background: linear-gradient(90deg, #48bb78, #38a169);
	}

	.era-progress-text {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 0.11rem;
		font-weight: bold;
		color: #2d3748;
		z-index: 1;
	}

	/* 响应式设计 */
	@media (max-width: 1200px) {
		.era-content-grid {
			grid-template-columns: 1fr;
			gap: 0.2rem;
		}

		.era-stats-panel {
			flex-direction: row;
		}

		.era-stats-panel {
			padding-top: 0;
		}

		.era-chart-section,
		.era-quality-section {
			flex: 1;
		}

		.page-title {
			display: block;

			.page-title-btn {
				display: flex;
				justify-content: space-between;
			}
		}
	}

	@media (max-width: 768px) {
		.era-container {
			padding: 00.17rem;
		}

		.era-main-title {
			font-size: 0.22rem;
		}

		.era-content-grid {
			gap: 00.17rem;
		}

		.era-stats-panel {
			flex-direction: column;
		}

		.era-ranking-table {
			font-size: 0.12rem;
		}

		.era-ranking-table th,
		.era-ranking-table td {
			padding: 0.08rem 0.06rem;
		}

		.era-name-col {
			min-width: 1.5rem;
		}

		.era-private-col {
			width: 1rem;
		}

		.era-growth-col {
			width: 0.8rem;
		}

		.era-school-col {
			width: 1.2rem;
		}
	}

	@media (max-width: 480px) {
		.era-container {
			padding: 0.1rem;
		}

		.era-main-title {
			font-size: 0.2rem;
		}

		.era-section-title {
			font-size: 0.2rem;
		}

		.era-ranking-table {
			font-size: 0.11rem;
		}

		.era-ranking-table th,
		.era-ranking-table td {
			padding: 0.06rem 0.04rem;
		}

		.era-table-header,
		.era-table-row {
			grid-template-columns: 1fr 1fr;
			gap: 0.1rem;
		}

		.era-table-header .era-depth-header,
		.era-table-row .era-progress-cell:last-child {
			display: none;
		}

		.era-rank-number {
			width: 0.24rem;
			height: 0.24rem;
			line-height: 0.24rem;
			font-size: 0.11rem;
		}
	}

	.era-content-grid {
		margin-top: 0.2rem;
		background: white;
		border-radius: 0.12rem;
		padding: 0.2rem;
		box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.08);
	}

	.page-title {
		justify-content: space-between;
		margin: 0 0 0.3rem;

		.page-title-main {
			font-size: 0.26rem;
			font-weight: bold;
		}

		.page-title-sub {
			color: #0BA29B;
			font-size: 0.22rem;
			font-weight: bold;
			margin-top: 0.12rem;
		}
	}

	#one {
		height: 2.7rem;
	}
	
	.dialog-down {
		width: 5rem;
		height:6rem;
		margin: 0 auto;
	
		::v-deep .el-dialog {
			width: 100% !important;
			overflow: auto
		}
	}
	
	@media (max-width: 768px) {
	
		.dialog-down {
			width: 90% !important;
		}
	}
</style>